module.exports = __webpack_public_path__ + "static/media/program.5571e7b8.svg";